/* eslint-disable @typescript-eslint/naming-convention */
// deps
import { useCallback } from "react";

// internal-deps
import { RenderingDetails, SavingsLineItemData, SavingsRightSectionType } from "@swiggy-private/cart-types";
import { isEmpty } from "@swiggy-private/js-utils";

// analytics
import { APPLY_COUPON_TEXTS } from "@cart-client/constants/Coupon";

export interface UseSavingsBenefitsReturnType {
    getSavingsBenefitsItem: () => SavingsLineItemData[];
}

export interface IProps {
    savingsBenefitsRenderingDetails: RenderingDetails;
}

export const useBenefitsData = ({ savingsBenefitsRenderingDetails }: IProps): UseSavingsBenefitsReturnType => {
    const getSavingsBenefitsItem = useCallback((): SavingsLineItemData[] => {
        if (isEmpty(savingsBenefitsRenderingDetails)) {
            return [];
        }

        const title: SavingsLineItemData["title"] = {
            value: savingsBenefitsRenderingDetails.value,
        };

        const rightSection = {
            type: SavingsRightSectionType.LABEL,
            value: APPLY_COUPON_TEXTS.APPLIED,
        };

        return [
            {
                icon: savingsBenefitsRenderingDetails.icon,
                title,
                rightSection,
            },
        ];
    }, [savingsBenefitsRenderingDetails]);

    return { getSavingsBenefitsItem };
};
